export type CssClassMap = { [className: string]: boolean };

export enum LoaderType {
  row = 'row',
  circle = 'circle'
}

export enum LoaderColour {
  default = 'default',
  primary = 'primary',
  secondary = 'secondary',
  info = 'info',
  success = 'success',
  warning = 'warning',
  danger = 'danger'
}
